import { Component } from 'shimmer'

import glsl from 'glslify'

import { CubeTextureLoader, ShaderMaterial, Mesh } from 'three'

export class Fresnel extends Component {
  constructor (geometry) {
    super('Fresnel')

    this.geometry = geometry

    this.uniforms = {
      uRefractionRatio: { value: 1.02 },
      uFresnelBias: { value: 0.1 },
      uFresnelPower: { value: 2.0 },
      uFresnelScale: { value: 1.0 },
      tCube: { value: null }
    }

    const path = "/images/cubemap/"
    const format = '.png'
    const urls = [
      path + 'px' + format, path + 'nx' + format,
      path + 'py' + format, path + 'ny' + format,
      path + 'pz' + format, path + 'nz' + format
    ]

    const textureCube = new CubeTextureLoader().load( urls )

    this.uniforms[ "tCube" ].value = textureCube

    this.material = new ShaderMaterial( {
      uniforms: this.uniforms,
      vertexShader: glsl(require('../shaders/fresnel.vert').default),
      fragmentShader: glsl(require('../shaders/fresnel.frag').default)
    })
    this.material.transparent = true

    this.mesh = new Mesh( this.geometry, this.material )

    this.add(this.mesh)
  }
}